import { useState, useEffect, useCallback } from 'react';
import { getToken, setToken, clearToken, parseJwt, type AuthUser } from '../lib/auth';

export function useAuth() {
  const [user, setUser] = useState<AuthUser | null>(() => {
    const token = getToken();
    return token ? parseJwt(token) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (token) {
      const parsed = parseJwt(token);
      setUser(parsed);
    }
    setLoading(false);
  }, []);

  const login = useCallback((token: string) => {
    setToken(token);
    setUser(parseJwt(token));
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setUser(null);
  }, []);

  return { user, loading, login, logout, isAuthenticated: !!user };
}
